import React, { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { FuelInteractiveIcon } from '@frete.com/fuel-react';
import { CloseContent, Container, Content } from './styled';
import { ModalProps } from './types';

const ModalContent: React.FC<PropsWithChildren<ModalProps>> = ({ children, onClose, open, showCloseButton = true }) => {
  if (!open) return null;

  return (
    <Container>
      <Content>
        {showCloseButton && (
          <CloseContent>
            <FuelInteractiveIcon data-testid="modal-close-button" icon="close" size="medium" onClick={onClose} />
          </CloseContent>
        )}
        <>{children}</>
      </Content>
    </Container>
  );
};

export const Modal: React.FC<ModalProps> = ({ ...props }) => ReactDOM.createPortal(ModalContent(props), document.body);
